/* Cart drawer add-on boxes (Cult Gaia style test, Oct 12).
   The theme only binds its AJAX add-to-cart handler to forms that existed at init time.
   The add-on boxes are rendered inside the drawer later, so on the first click we ask the theme
   to bind them (ajaxCart.init adds its submit handler to any f8pr form not yet initialised).
   If ajaxCart is missing, the form still works as a normal /cart/add post. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#cart .cg-addon__check');
    if (!btn) return;
    var form = btn.closest('form');
    if (!form || form.classList.contains('cart-initialized')) return;
    try {
      if (window.ajaxCart && typeof window.ajaxCart.init === 'function') window.ajaxCart.init();
    } catch (err) {}
  }, true);
})();
